<template lang="pug">
.card.c-hand(@click="$emit('click')")
  .card-body
    .float-right
      i.fa.fa-chevron-right.text-primary
    .columns.align-items-center
      .column.col-12(v-if="mensagem.remetente")
        text-output(
          :label="'mensagem.remetente' | tModel",
          :text="mensagem.remetente.razao_social"
        )
      .column.col-12(v-if="mensagem.destinatario")
        text-output(
          :label="'mensagem.destinatario' | tModel",
          :text="mensagem.destinatario.razao_social"
        )
      .column.col-12
        text-output(
          :label="'mensagem.titulo' | tModel",
          :text="mensagem.titulo"
        )
    .divider
    .d-flex.justify-content-between.mt-2
      i.tooltip.tooltip-right(
        :class="icon",
        :data-tooltip="`enums.db.enum_mensagem_status.${mensagem.status}` | translate"
      )
      .abbr {{ mensagem.enviado_em | date }}
</template>

<script>
export default {
  props: { mensagem: { type: Object, required: true } },
  computed: {
    icon() {
      switch (this.mensagem.status) {
        case "lida":
          return "fa fa-envelope-open-o fa-lg text-primary";
        case "enviada":
          return "fa fa-envelope-o fa-lg text-success";
        case "respondida":
          return "fa fa-reply fa-lg text-warning";
      }
    },
  },
};
</script>
